'use client';

import Link from 'next/link';
import { trackEvent } from '../../lib/analytics';
import { Button, type ButtonProps } from '../button';

interface TrackedButtonProps
  extends Omit<ButtonProps, 'onClick' | 'asChild' | 'isLoading' | 'loadingText' | 'loadingMode'> {
  href: string;
  bannerName: string;
  children: React.ReactNode;
  additionalParams?: Record<string, unknown>;
}

export function TrackedButton({
  href,
  bannerName,
  children,
  additionalParams,
  ...buttonProps
}: TrackedButtonProps) {
  const handleClick = () => {
    trackEvent('banner_click', bannerName, additionalParams);
  };

  return (
    <Button asChild {...buttonProps} onClick={handleClick}>
      <Link href={href}>{children}</Link>
    </Button>
  );
}
